"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.convertGregorianToHijriDate = convertGregorianToHijriDate;
exports.convertHijriToGregorianDate = convertHijriToGregorianDate;
exports.generatePaxId = generatePaxId;
exports.getAvailableFrequentFlyers = getAvailableFrequentFlyers;
exports.getDisclaimersQuery = getDisclaimersQuery;
exports.getExtraBaggageTotals = getExtraBaggageTotals;
exports.getFlightBaggageInfo = getFlightBaggageInfo;
exports.getFrequentFlyersFromSavedTraveller = getFrequentFlyersFromSavedTraveller;
exports.getFullTripBaggageInfo = getFullTripBaggageInfo;
exports.getMultiSsrPayloadFromState = getMultiSsrPayloadFromState;
exports.getSsrPayloadFromState = getSsrPayloadFromState;
exports.getTravellersList = getTravellersList;
exports.getTravellersWithSSR = getTravellersWithSSR;
exports.isHijri = isHijri;
exports.isValidContactState = isValidContactState;
exports.isValidContactValue = isValidContactValue;
exports.removeTrailingZeroFromPrice = removeTrailingZeroFromPrice;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _frequentFlyer = _interopRequireDefault(require("../factories/frequent-flyer.factory"));
var _ssrPayload = _interopRequireWildcard(require("../factories/ssr-payload.factory"));
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isFinite2 = _interopRequireDefault(require("lodash/isFinite"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _reduce2 = _interopRequireDefault(require("lodash/reduce"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _get_date = _interopRequireDefault(require("date-fns/get_date"));
var _get_year = _interopRequireDefault(require("date-fns/get_year"));
var _get_month = _interopRequireDefault(require("date-fns/get_month"));
var _is_valid = _interopRequireDefault(require("date-fns/is_valid"));
var _hijriConverter = require("hijri-converter");
var _format = require("@tajawal/web-core-sdk-v2/lib/utils/format.utils");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _constants2 = require("../constants");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getAvailableFrequentFlyers(primaryCarriers, language) {
  if (language === void 0) {
    language = _constants.LANGUAGE.EN;
  }
  var primaryFrequentFlyers = (0, _pick2.default)(_constants2.FREQUENT_FLYERS_MAP, primaryCarriers);
  var frequentFlyerGroups = (0, _map2.default)(primaryFrequentFlyers, "group");
  var secondaryCarriers = (0, _filter2.default)(_constants2.FREQUENT_FLYER_GROUP_MAP, function (groupCarriers, groupKey) {
    return (0, _includes2.default)(frequentFlyerGroups, groupKey);
  });
  var allCarriers = _concat2.default.apply(void 0, [primaryCarriers].concat(secondaryCarriers));
  var frequentFlyerMap = (0, _pick2.default)(_constants2.FREQUENT_FLYERS_MAP, allCarriers);
  return (0, _map2.default)(frequentFlyerMap, function (frequentFlyer) {
    return (0, _frequentFlyer.default)(frequentFlyer, language);
  });
}
function getSsrPayloadFromState(travellerValues) {
  var ssrPayload = (0, _map2.default)(travellerValues, _ssrPayload.default);
  return (0, _filter2.default)(ssrPayload, function (ssr) {
    return (0, _isPlainObject2.default)(ssr);
  });
}
function getMultiSsrPayloadFromState(travellerValues) {
  var ssrPayload = (0, _flatMap2.default)(travellerValues, _ssrPayload.multiSsrPayloadFactory);
  var mergedPayload = (0, _reduce2.default)(ssrPayload, function (result, item) {
    if (item && item.productId) {
      var existingProduct = (0, _find2.default)(result, {
        productId: item.productId
      });
      if (existingProduct) {
        existingProduct.items = (0, _concat2.default)(existingProduct.items, item.items);
      } else {
        result.push(item);
      }
    }
    return result;
  }, []);
  return (0, _filter2.default)(mergedPayload, function (ssr) {
    return !(0, _isEmpty2.default)(ssr);
  });
}
function getTravellersWithSSR(travellers) {
  var _travellers$;
  var firstTravellerProducts = travellers === null || travellers === void 0 ? void 0 : (_travellers$ = travellers[0]) === null || _travellers$ === void 0 ? void 0 : _travellers$.products;
  var hasMultiProduct = (0, _size2.default)(firstTravellerProducts) > 1;
  var validatingCarrierFields = (0, _map2.default)(firstTravellerProducts, "validatingCarrier");
  var hasDuplicatedValidatingCarrier = validatingCarrierFields.length > new Set(validatingCarrierFields).size;
  if (!hasMultiProduct || !hasDuplicatedValidatingCarrier) {
    return travellers;
  }
  return (0, _map2.default)(travellers, function (traveller) {
    var products = (0, _get2.default)(traveller, "products");
    var firstProductWithSSRValue = (0, _find2.default)(products, function (product) {
      var _product$ssr, _product$ssr$frequent;
      return product === null || product === void 0 ? void 0 : (_product$ssr = product.ssr) === null || _product$ssr === void 0 ? void 0 : (_product$ssr$frequent = _product$ssr.frequentFlyer) === null || _product$ssr$frequent === void 0 ? void 0 : _product$ssr$frequent.number;
    });
    var newProducts = (0, _reduce2.default)(products, function (endProducts, product) {
      var _firstProductWithSSRV, _objectSpread2;
      return _objectSpread(_objectSpread({}, endProducts), {}, (_objectSpread2 = {}, _objectSpread2[product.productId] = _objectSpread(_objectSpread({}, product), {}, {
        ssr: _objectSpread(_objectSpread({}, product.ssr), {}, {
          frequentFlyer: firstProductWithSSRValue === null || firstProductWithSSRValue === void 0 ? void 0 : (_firstProductWithSSRV = firstProductWithSSRValue.ssr) === null || _firstProductWithSSRV === void 0 ? void 0 : _firstProductWithSSRV.frequentFlyer
        })
      }), _objectSpread2));
    }, {});
    return _objectSpread(_objectSpread({}, traveller), {}, {
      products: newProducts
    });
  });
}
function generatePaxId(type, seatIndex) {
  return [type, seatIndex].join("_");
}
function isHijri(date) {
  return (0, _is_valid.default)(new Date(date)) && (0, _get_year.default)(date) < 1600;
}
function convertHijriToGregorianDate(hijriDate) {
  var _toGregorian = (0, _hijriConverter.toGregorian)((0, _get_year.default)(hijriDate), (0, _get_month.default)(hijriDate), (0, _get_date.default)(hijriDate)),
    year = _toGregorian.gy,
    month = _toGregorian.gm,
    day = _toGregorian.gd;
  return new Date(year, month, day);
}
function convertGregorianToHijriDate(gregDate) {
  var _toHijri = (0, _hijriConverter.toHijri)((0, _get_year.default)(gregDate), (0, _get_month.default)(gregDate), (0, _get_date.default)(gregDate)),
    year = _toHijri.hy,
    month = _toHijri.hm,
    day = _toHijri.hd;
  return new Date(year, month, day);
}
function getFrequentFlyersFromSavedTraveller(_ref) {
  var _traveller$frequentFl;
  var traveller = _ref.traveller,
    carriers = _ref.carriers;
  var frequentFlyerList = (_traveller$frequentFl = traveller === null || traveller === void 0 ? void 0 : traveller.frequentFlyer) !== null && _traveller$frequentFl !== void 0 ? _traveller$frequentFl : [];
  var frequentFlyer = (0, _find2.default)(frequentFlyerList, function (ff) {
    return (0, _includes2.default)(carriers, ff === null || ff === void 0 ? void 0 : ff.FFProgram);
  });
  return (0, _frequentFlyer.default)({
    operatorCode: frequentFlyer === null || frequentFlyer === void 0 ? void 0 : frequentFlyer.FFProgram,
    number: frequentFlyer === null || frequentFlyer === void 0 ? void 0 : frequentFlyer.FFNumber
  });
}
function getFlightBaggageInfo(_ref2) {
  var _luggageInfo$0$isFull, _luggageInfo$;
  var luggageInfo = _ref2.luggageInfo,
    baggageInfo = _ref2.baggageInfo,
    productId = _ref2.productId;
  var isFullTrip = (_luggageInfo$0$isFull = luggageInfo === null || luggageInfo === void 0 ? void 0 : (_luggageInfo$ = luggageInfo[0]) === null || _luggageInfo$ === void 0 ? void 0 : _luggageInfo$.isFullTrip) !== null && _luggageInfo$0$isFull !== void 0 ? _luggageInfo$0$isFull : false;
  if (isFullTrip) {
    return getFullTripBaggageInfo({
      luggageInfo: luggageInfo,
      baggageInfo: baggageInfo,
      productId: productId
    });
  }
  return (0, _map2.default)(baggageInfo, function (baggageUnit) {
    var luggage = (0, _find2.default)(luggageInfo, {
      id: baggageUnit.legId
    });
    return _objectSpread(_objectSpread({}, baggageUnit), {}, {
      luggage: luggage,
      isFullTrip: false,
      productId: productId
    });
  });
}
function getFullTripBaggageInfo(_ref3) {
  var _luggageInfo$2, _luggageInfo$3;
  var luggageInfo = _ref3.luggageInfo,
    baggageInfo = _ref3.baggageInfo,
    productId = _ref3.productId;
  return [_objectSpread(_objectSpread({}, baggageInfo[0]), {}, {
    luggage: (_luggageInfo$2 = luggageInfo === null || luggageInfo === void 0 ? void 0 : luggageInfo[0]) !== null && _luggageInfo$2 !== void 0 ? _luggageInfo$2 : {},
    legId: luggageInfo === null || luggageInfo === void 0 ? void 0 : (_luggageInfo$3 = luggageInfo[0]) === null || _luggageInfo$3 === void 0 ? void 0 : _luggageInfo$3.id,
    isFullTrip: true,
    productId: productId
  })];
}
function getExtraBaggageTotals(_ref4) {
  var travellers = _ref4.travellers,
    $currency = _ref4.$currency;
  var totals = (0, _reduce2.default)(travellers, function (totals, traveller) {
    var _traveller$totals$lug, _traveller$totals;
    return totals + ((_traveller$totals$lug = traveller === null || traveller === void 0 ? void 0 : (_traveller$totals = traveller.totals) === null || _traveller$totals === void 0 ? void 0 : _traveller$totals.luggage) !== null && _traveller$totals$lug !== void 0 ? _traveller$totals$lug : 0);
  }, 0);
  return {
    hasExtraBaggage: totals > 0,
    displayTotals: $currency.formatPriceWithDecimals($currency.convertPrice(totals), 2),
    currency: $currency.currentCurrency
  };
}
function getDisclaimersQuery(itinerary) {
  var disclaimers = (0, _map2.default)(itinerary.legs, function (_ref5) {
    var segments = _ref5.segments;
    var routes = (0, _map2.default)(segments, function (segment) {
      return [segment.departureCode, segment.arrivalCode].join("-");
    });
    var flightCodes = (0, _map2.default)(segments, function (segment) {
      return segment.flightCode;
    });
    var layovers = (0, _map2.default)(segments, function (_ref6) {
      var layoverInSeconds = _ref6.layoverInSeconds;
      return Number(layoverInSeconds) * 1000;
    });
    layovers = (0, _filter2.default)(layovers, function (l) {
      return (0, _isFinite2.default)(l);
    });
    return [(0, _join2.default)(routes, ","), (0, _join2.default)(flightCodes, ","), (0, _join2.default)(layovers, ",")].join("/");
  });
  return disclaimers.join("*");
}
function isValidContactState(contact) {
  return (0, _isPlainObject2.default)(contact);
}
function isValidContactValue(key, value) {
  switch (key) {
    case "title":
      return _constants2.TRAVELLERS_TITLE_OPTIONS.includes(value);
    case "firstName":
    case "lastName":
    case "email":
      return typeof value === "string";
    case "phone":
      return /^\d+$/.test(String(value));
    case "dialCode":
      return /^\+[\d-]+$/.test(String(value));
    default:
      return false;
  }
}
function groupTravellersByType(travellers) {
  var _travellers$0$display, _travellers$2, _travellers$2$display, _travellers$3;
  var travellerTotal = 0;
  var travellerBase = 0;
  var travellerTax = 0;
  var travellerVat = 0;
  var travellerLuggage = 0;
  var hasExtraBaggageAdded = false;
  (0, _forEach2.default)(travellers, function (traveller) {
    var _traveller$totals2, _traveller$ssr$luggag, _traveller$ssr;
    var _ref7 = (_traveller$totals2 = traveller === null || traveller === void 0 ? void 0 : traveller.totals) !== null && _traveller$totals2 !== void 0 ? _traveller$totals2 : {},
      total = _ref7.total,
      base = _ref7.base,
      tax = _ref7.tax,
      vat = _ref7.vat,
      luggage = _ref7.luggage;
    if (!(0, _isEmpty2.default)((_traveller$ssr$luggag = traveller === null || traveller === void 0 ? void 0 : (_traveller$ssr = traveller.ssr) === null || _traveller$ssr === void 0 ? void 0 : _traveller$ssr.luggage) !== null && _traveller$ssr$luggag !== void 0 ? _traveller$ssr$luggag : [])) {
      hasExtraBaggageAdded = true;
    }
    travellerTotal += total;
    travellerBase += base;
    travellerTax += tax;
    travellerVat += vat;
    travellerLuggage += luggage;
  });
  var currentCurrency = (_travellers$0$display = travellers === null || travellers === void 0 ? void 0 : (_travellers$2 = travellers[0]) === null || _travellers$2 === void 0 ? void 0 : (_travellers$2$display = _travellers$2.displayTotals) === null || _travellers$2$display === void 0 ? void 0 : _travellers$2$display.currency) !== null && _travellers$0$display !== void 0 ? _travellers$0$display : "";
  var travellerType = travellers === null || travellers === void 0 ? void 0 : (_travellers$3 = travellers[0]) === null || _travellers$3 === void 0 ? void 0 : _travellers$3.type;
  var travellerCount = travellers.length;
  return {
    count: travellerCount,
    type: travellerType,
    total: (0, _format.formatPriceWithDecimals)({
      price: travellerTotal,
      decimal: 0,
      currentCurrency: currentCurrency
    }),
    base: (0, _format.formatPriceWithDecimals)({
      price: travellerBase,
      decimal: 0,
      currentCurrency: currentCurrency
    }),
    tax: (0, _format.formatPriceWithDecimals)({
      price: travellerTax,
      decimal: 0,
      currentCurrency: currentCurrency
    }),
    vat: (0, _format.formatPriceWithDecimals)({
      price: travellerVat,
      decimal: 0,
      currentCurrency: currentCurrency
    }),
    luggage: (0, _format.formatPriceWithDecimals)({
      price: travellerLuggage,
      decimal: 0,
      currentCurrency: currentCurrency
    }),
    hasExtraBaggageAdded: hasExtraBaggageAdded,
    currency: currentCurrency
  };
}
function getTravellersList(travellers) {
  var adults = (0, _filter2.default)(travellers, function (traveller) {
    return traveller.type === _constants2.TRAVELLERS_TYPES_CODES_MAP.ADT;
  });
  var children = (0, _filter2.default)(travellers, function (traveller) {
    return traveller.type === _constants2.TRAVELLERS_TYPES_CODES_MAP.CH;
  });
  var infants = (0, _filter2.default)(travellers, function (traveller) {
    return traveller.type === _constants2.TRAVELLERS_TYPES_CODES_MAP.INF;
  });
  var adultsPrice = adults.length > 0 ? groupTravellersByType(adults) : {};
  var childrenPrice = children.length > 0 ? groupTravellersByType(children) : {};
  var infantsPrice = infants.length > 0 ? groupTravellersByType(infants) : {};
  return {
    adults: adultsPrice,
    children: childrenPrice,
    infants: infantsPrice
  };
}
function removeTrailingZeroFromPrice(price) {
  return price.replace(/\.00+/, "");
}